import React, {useState} from 'react';
import PropTypes, {InferProps} from 'prop-types';

import {OnboardingFlowContext} from 'context';
import {ActivePathType} from 'commons/types/Types';

const defaultContextValue = {
    moduleStep: false,
    flow: {
        data: {
            viewId: 0,
            fatherId: 0,
            linkedFatherId: 0,
            linkedChildId: 0,
            index: 0,
            component: null,
            view: null,
            thirdLevel: false,
            exact: false,
            orderId: 0,
            layout: '',
            showLinearProgress: false,
            id: '',
            expandKey: '',
            showMenu: false,
            path: '',
            name: '',
            title: '',
            moduleStep: false,
        },
    },
};

/**
 * Onboarding Flow Context Provider
 * @param {InferProps<typeof EfeFlowProvider.propTypes>} props
 * @returns {JSX.Element}
 * @constructor
 */
function EfeFlowProvider(props: InferProps<typeof EfeFlowProvider.propTypes>) {
    const {children} = props;
    const [moduleStep, setModuleStep] = useState<boolean>(false);
    const [flow, setFlow] = useState<ActivePathType>(defaultContextValue.flow);

    const updateFlow = (data: ActivePathType) => {
        setFlow(data);
    };

    const updateModuleStep = (flag: boolean) => {
        setModuleStep(flag);
    };

    return (
        <OnboardingFlowContext.Provider
            value={{
                flow,
                updateFlow,
                moduleStep,
                updateModuleStep,
            }}>
            {children}
        </OnboardingFlowContext.Provider>
    );
}

EfeFlowProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default EfeFlowProvider;
